// This action is only invoked by saveTrack and useWaypoints
export default function updateProperties(
    {properties}: UpdateTrackPointPropertiesAction,
    setTracks: SetState<{[localId: string]: Track}>
) {
    const {localId, trackLocalId} = properties;

    setTracks((latestTracks) => {
        const latestTrack = latestTracks[trackLocalId];
        if (!latestTrack.isGeometryLoaded) throw new Error();
        const latestTrackPoint = latestTrack.points[localId];

        return {
            ...latestTracks,
            [trackLocalId]: {
                ...latestTrack,
                points: {
                    ...latestTrack.points,
                    [localId]: {
                        ...latestTrackPoint,
                        properties: {
                            ...latestTrackPoint.properties,
                            ...properties,
                        },
                    },
                },
            },
        };
    });

    return [localId];
}
